import {StyleSheet} from 'aphrodite';

import {
  BASIC_MARGIN,
  COL_PADDING_OFFSET,
  WITHOUT_BUTTON_FOCUS_STYLING,
} from 'analyses/alignment/modals/StyleConstants';
import {Operator} from 'search/SearchConstants';
import {
  FONT_PROXIMA_13,
  FONT_PROXIMA_14,
  FONT_PROXIMA_18,
  FONT_WEIGHT_PROXIMA_SEMIBOLD,
} from 'styles/FontConstants';
import {GRAY_DARKER, GRAY_LIGHT, NEAR_BLACK, RED_DARK} from 'ui-library/Colors';

export const BLAST_MODAL_TITLE = 'Basic Local Alignment Search Tool (BLAST)';
export const BLASTN_INFO_MESSAGE = 'Use a nucleotide query to search for nucleotide sequences.';
export const BLASTP_INFO_MESSAGE = 'Use an amino acid query to search for amino acid sequences.';
export const BLASTX_INFO_MESSAGE = 'Use a translated nucleotide query to search for amino acid sequences.';
export const TBLASTN_INFO_MESSAGE = 'Use an amino acid query to search for translated nucleotide sequences.';
export const TBLASTX_INFO_MESSAGE =
  'Use a translated nucleotide query to search for translated nucleotide sequences.';

export const OPERATOR_TO_SECONDARY_LABEL = {
  [Operator.BLASTN]: BLASTN_INFO_MESSAGE,
  [Operator.BLASTP]: BLASTP_INFO_MESSAGE,
  [Operator.BLASTX]: BLASTX_INFO_MESSAGE,
  [Operator.TBLASTN]: TBLASTN_INFO_MESSAGE,
  [Operator.TBLASTX]: TBLASTX_INFO_MESSAGE,
};

export const styles = StyleSheet.create({
  headerLabel: {...FONT_PROXIMA_14},
  sectionTitle: {...FONT_PROXIMA_13, marginBottom: '10px'},
  sectionLabel: {...FONT_PROXIMA_13, color: GRAY_DARKER},
  blastTypeLabel: {...FONT_PROXIMA_13, color: NEAR_BLACK, fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD},
  sequenceInput: {alignItems: 'center'},
  metadataColumn: {
    display: 'inline-block',
    paddingBottom: '10px',
    ':not(:first-child)': {
      paddingLeft: '10px',
    },
  },
  fileSpinner: {verticalAlign: 'bottom', marginBottom: '-3px'},
  entitySearch: {width: '300px'},
  errorInput: {border: `1px solid ${RED_DARK}`},
  stepNavMarginAdjustment: {marginBottom: '20px'},
  colPaddingOffset: COL_PADDING_OFFSET,
  basicVerticalMargin: {marginTop: '17px'},
  param: {marginBottom: BASIC_MARGIN},
  paramsDropdownTitle: {
    ...FONT_PROXIMA_18,
    color: GRAY_DARKER,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
  },
  toggle: {cursor: 'pointer', color: GRAY_DARKER},
  icon: {marginRight: 8, ...FONT_PROXIMA_13},
  horizontal: {
    marginLeft: 10,
    marginRight: 20,
    textAlign: 'center',
    borderBottom: `1.5px solid ${GRAY_LIGHT}`,
    flex: 1,
  },
  withoutButtonFocusStyling: WITHOUT_BUTTON_FOCUS_STYLING,
});

export const AlignmentConstants = {
  columnHeight: {
    normal: '65px',
    compact: '53px',
  },
  columnGap: {
    normal: '4px',
    compact: '1px',
  },
  tickHeight: {
    normal: '37px',
    compact: '32px',
  },
} as const;
